import React from "react";
import { Box, Stack, Spacer, Divider } from "digiwash-components";
import PageContainerShape from "../../containers/PageContainerShape";
import CustomIcon from "../../components/CustomIcon";
import SectionTitle from "../../components/SectionTitle";
import ServicesPrivilegeList from "../../components/ServicesPrivilegeList";

interface PropsType {
  title?: string;
  subTitle?: React.ReactNode;
  icon?: string;
  featured?: boolean;
  children: React.ReactNode;
  privilegeList?: string[];
}

function Section(props: PropsType) {
  return (
    <>
      {props.title ? (
        <>
          <Box px="xl">
            <Stack distribution="space-between">
              <Stack>
                <CustomIcon icon={props.icon} width={32} height={32} />
                <Spacer size="m" />
                <SectionTitle title={props.title} />
                <Spacer size="m" />
              </Stack>
              {props.subTitle}
            </Stack>
          </Box>
          <Divider size="xxl" />
        </>
      ) : null}
      <PageContainerShape
        featured={props.featured}
        fullRadius={true}
        bg="common.white"
        p="m"
      >
        {props.featured && props.privilegeList ? (
          <Box p="m">
            <ServicesPrivilegeList items={props.privilegeList} />
          </Box>
        ) : null}
        {props.children}
      </PageContainerShape>
    </>
  );
}

export default Section;
